import { CURRENCY_FIELDS } from 'src/constants'

export const getFormattedTitle = (
  name: string,
  title: string,
  currency: string,
  distanceMetric: string,
) => {
  const isCurrencyField = CURRENCY_FIELDS.includes(name)
  const isOdometer = name === 'odometer'

  if (isCurrencyField) return `${title} (${currency.toUpperCase()})`

  if (isOdometer) return `${title} (${distanceMetric})`

  return title
}
